var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_291_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5975 10.2601C23.9075 10.4501 23.4975 11.1602 23.6875 11.8502C23.9075 12.6702 24.0175 13.5202 24.0175 14.3802C24.0175 16.9502 23.0175 19.3701 21.1975 21.1801C19.3775 22.9901 16.9675 24.0002 14.3975 24.0002C11.8275 24.0002 9.40747 23.0001 7.59747 21.1801C5.78747 19.3601 4.77753 16.9502 4.77753 14.3802C4.77753 11.8102 5.77747 9.39015 7.59747 7.58015C9.41747 5.76015 11.8275 4.76015 14.3975 4.76015C15.6875 4.76015 16.9275 5.01015 18.1075 5.50015C18.7675 5.78015 19.5275 5.46016 19.8075 4.80016C20.0875 4.14016 19.7675 3.38016 19.1075 3.10016C17.6175 2.48016 16.0275 2.16016 14.3975 2.16016C12.7675 2.16016 11.1475 2.48015 9.64752 3.12015C8.19752 3.74015 6.88752 4.62016 5.76752 5.74016C4.64752 6.86016 3.76752 8.17015 3.14752 9.62015C2.50752 11.1301 2.1875 12.7301 2.1875 14.3701C2.1875 16.0101 2.50752 17.6201 3.14752 19.1201C3.76752 20.5701 4.64752 21.8802 5.76752 23.0002C6.88752 24.1202 8.19752 25.0001 9.64752 25.6201C11.1575 26.2601 12.7575 26.5801 14.3975 26.5801C16.0375 26.5801 17.6475 26.2601 19.1475 25.6201C20.5975 25.0001 21.9075 24.1202 23.0275 23.0002C24.1475 21.8802 25.0275 20.5701 25.6475 19.1201C26.2875 17.6101 26.6075 16.0101 26.6075 14.3701C26.6075 13.2801 26.4675 12.2102 26.1775 11.1702C25.9875 10.4802 25.2775 10.0701 24.5875 10.2601H24.5975Z",
    fill: "url(#paint0_linear_291_1607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.357 12.8802C9.84699 12.3702 9.02703 12.3702 8.52703 12.8802C8.01703 13.3902 8.01703 14.2102 8.52703 14.7102L12.857 19.0402C13.097 19.2802 13.427 19.4202 13.777 19.4202C13.797 19.4202 13.827 19.4202 13.847 19.4202C14.217 19.4002 14.557 19.2202 14.787 18.9402L24.037 7.3702C24.487 6.8102 24.397 6.0002 23.837 5.5502C23.277 5.1002 22.467 5.1902 22.017 5.7502L13.667 16.1902L10.357 12.8802Z",
    fill: "url(#paint1_linear_291_1607)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_291_1607",
    x: 0.0874999,
    y: 0.0601561,
    width: 30.7019,
    height: 30.6999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.04,
    dy: 1.04
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_291_1607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_291_1607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291_1607",
    x1: 24.2475,
    y1: 3.69016,
    x2: 10.4375,
    y2: 18.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B309"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291_1607",
    x1: 23.527,
    y1: 3.0202,
    x2: 9.70699,
    y2: 18.0202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B309"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerif);
export default __webpack_public_path__ + "static/media/verif.2c6e85fe3ffbb06d9c1c6d317bf3002d.svg";
export { ForwardRef as ReactComponent };